import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomHamburguerMenuComponent } from './hamburguer-menu.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { HamburgerMenuService } from '@spartacus/storefront';
import { CustomHamburgerMenuService } from './hamburger-menu.service';

@NgModule({
  imports: [CommonModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        HamburgerMenuComponent: {
          component: CustomHamburguerMenuComponent,
        },
      },
    }),
    {
      provide: HamburgerMenuService,
      useClass: CustomHamburgerMenuService,
    },
  ],
  declarations: [CustomHamburguerMenuComponent],
  exports: [CustomHamburguerMenuComponent],
})
export class CustomHamburguerMenuModule {}
